import { transformErrorResponse } from "../../transformErrorResponse"
import { TuvesENTITY } from "sigo-entities"
import { AtcApiBuilder } from "."

export const PERU_9112_TuvesOrder = (build: AtcApiBuilder) => {
    return {
        getByIdTuvesOrders: build.query<TuvesENTITY[], string>({
            query: (userId) => `procesos/PERU_9112_TuvesOrder/${userId}`,
            providesTags: (result, error, userId) =>
                result
                    ? [
                        // tag individual por cada orden
                        ...result.map((order) => ({
                            type: 'TuvesOrders' as const,
                            id: order._id,
                        })),
                        // y un tag general de la lista de ese usuario
                        { type: 'TuvesOrders' as const, id: `USER-${userId}` },
                    ]
                    : [{ type: 'TuvesOrders' as const, id: `USER-${userId}` }],
            transformErrorResponse
        }),
        getTransitTuvesOrders: build.query<{ transito: number }, { id_recurso: string, codigo: number }>({
            query: ({ id_recurso, codigo }) => `procesos/PERU_9112_TuvesOrder/calculate-transit/${id_recurso}/${codigo}`,
            transformErrorResponse
        }),
        addInventoryTuvesOrders: build.mutation<TuvesENTITY, { id: string, body: { ID_StockPersonal: number, cantidad: number, Serie?: { Serie: string, ID_StockPersonalEquipos: number } } }>({
            query: ({ body, id }) => ({
                url: `procesos/PERU_9112_TuvesOrder/add-inventory/${id}`,
                method: "PUT",
                body,
            }),
            invalidatesTags: (result, error, { id }) => [
                { type: 'TuvesOrders' as const, id },
            ],
            transformErrorResponse
        }),
        deleteInventoryTuvesOrders: build.mutation<TuvesENTITY, { id: string, codigo: number, serie: string }>({
            query: ({ id, codigo, serie }) => ({
                url: `procesos/PERU_9112_TuvesOrder/delete-inventory/${id}/${codigo}?serie=${serie}`,
                method: "PUT",
            }),
            invalidatesTags: (result, error, { id }) => [
                { type: 'TuvesOrders' as const, id },
            ],
            transformErrorResponse
        }),
        finalizeTuvesOrders: build.mutation<TuvesENTITY, { id: string }>({
            query: ({ id }) => ({
                url: `procesos/PERU_9112_TuvesOrder/finalize/${id}`,
                method: "PUT"
            }),
            invalidatesTags: (result, error, { id }) => [
                // invalida la orden puntual
                { type: 'TuvesOrders' as const, id },
                // y también la lista del usuario (para que se refresque)
                // { type: 'TuvesOrders' as const, id: `USER-${userId}` },
            ],
            transformErrorResponse
        })
    }
}